import classnames from 'classnames'
import { graphql } from 'gatsby'
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image'
import React from 'react'

import Link from '@/components/link/link'
import { getImageAspectRatioClass } from '@/utils/get-image-aspect-ratio-class'

import * as styles from './logos.module.scss'

export interface Logo {
  originalId: string
  gatsbyImageData: IGatsbyImageData
  title: string
  alt: string
  customData?: Record<string, string>
  height: number
  width: number
}

interface PartnersProps {
  logos: Logo[] | null
  size: 'small' | 'normal' | 'big'
  grayscale?: boolean
  title?: string
}

const Logos: React.FC<PartnersProps> = ({ logos, grayscale, title, size }) => {
  return (
    <div
      className={`container mx-auto w-90 ${logos && logos?.length > 0 ? styles.logosSection : ''}`}
    >
      {title && <h2 className="pb-4">{title}/</h2>}

      <div className={`row justify-content-center mt-3`}>
        {logos?.map((logo) => {
          const { customData } = logo
          const website = customData?.website ?? ''
          const aspectRatio = getImageAspectRatioClass(styles, logo)
          const grey = grayscale === true ? styles.grayscale : ''

          return (
            <div
              key={logo.originalId}
              className={classnames(
                `col-6 col-md-4 col-lg-3 sm-2 text-center mb-5`,
                aspectRatio,
                grey,
                { [styles.small]: size === 'small' },
                { [styles.normal]: size === 'normal' || !size },
                { [styles.big]: size === 'big' }
              )}
            >
              <Link
                to={website}
                aria-label={
                  logo.title ? `Website of ${logo.title}` : `${logo.alt} `
                }
              >
                <GatsbyImage
                  key={logo.title}
                  image={logo.gatsbyImageData}
                  alt={logo.alt}
                  title={logo.title}
                />
              </Link>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default Logos

export const query = graphql`
  fragment Logos on DatoCmsLogo {
    __typename
    id
    grayscale
    navigationLabel
    size
    logos {
      originalId
      gatsbyImageData(height: 200)
      title
      alt
      customData
      height
      width
    }
    title
  }
`
